import React, { useState, useEffect } from 'react';
import '../styles/Navbar.css';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleScroll = (id) => {
    setMenuOpen(false);
    if (location.pathname === '/') {
      // 如果在首頁，滾動到指定區塊
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const socialLinks = (
    <div className="navbar-social">
      <a href="https://www.facebook.com/lanhung.interiordesign/" target="_blank" rel="noopener noreferrer" className="navbar-social-link" aria-label="Facebook">
        <FontAwesomeIcon icon={faFacebookF} />
      </a>
      <a href="https://www.instagram.com/lanhung_interior" target="_blank" rel="noopener noreferrer" className="navbar-social-link" aria-label="Instagram">
        <FontAwesomeIcon icon={faInstagram} />
      </a>
    </div>
  );

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/" onClick={() => handleScroll('hero-section')}>
            <img 
              src={require('../images/logo.png')} 
              alt="聯漢室內設計 LOGO" 
              className="nav-logo"
            />
          </Link>
        </div>
        <div className="menu-icon" onClick={toggleMenu}>
          <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </div>
        <div className="navbar-right">
          <ul className={menuOpen ? 'navbar-menu active' : 'navbar-menu'}>
            <li className="navbar-item">
              {location.pathname === '/' ? (
                <a 
                  href="#about" 
                  className="navbar-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleScroll('about');
                  }}
                >
                  關於我們
                </a>
              ) : (
                <Link 
                  to="/#about" 
                  className="navbar-link"
                  onClick={() => setMenuOpen(false)}
                >
                  關於我們
                </Link>
              )}
            </li>
            <li className="navbar-item">
              {location.pathname === '/' ? (
                <a 
                  href="#services" 
                  className="navbar-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleScroll('services');
                  }}
                >
                  服務項目
                </a>
              ) : (
                <Link 
                  to="/#services" 
                  className="navbar-link"
                  onClick={() => setMenuOpen(false)}
                >
                  服務項目
                </Link>
              )}
            </li>
            <li className="navbar-item">
              {location.pathname === '/' ? (
                <a 
                  href="#process" 
                  className="navbar-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleScroll('process');
                  }}
                >
                  服務流程
                </a>
              ) : (
                <Link 
                  to="/#process" 
                  className="navbar-link"
                  onClick={() => setMenuOpen(false)}
                >
                  服務流程
                </Link>
              )}
            </li>
            <li className="navbar-item">
              {location.pathname === '/' ? (
                <a 
                  href="#projects" 
                  className="navbar-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleScroll('projects');
                  }}
                >
                  精選案例
                </a>
              ) : (
                <Link 
                  to="/#projects" 
                  className="navbar-link"
                  onClick={() => setMenuOpen(false)}
                >
                  精選案例
                </Link>
              )}
            </li>
            <li className="navbar-item">
              {location.pathname === '/' ? (
                <a 
                  href="#contact" 
                  className="navbar-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleScroll('contact');
                  }}
                >
                  聯絡我們
                </a>
              ) : (
                <Link 
                  to="/#contact" 
                  className="navbar-link"
                  onClick={() => setMenuOpen(false)}
                >
                  聯絡我們
                </Link>
              )}
            </li>
            {menuOpen && (
              <li className="navbar-mobile-social">
                {socialLinks}
              </li>
            )}
          </ul>
          {!menuOpen && socialLinks}
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 